// =============================================================================
// AI ASSISTANT BUTTON - Floating action button to open assistant
// =============================================================================

import { Bot, Sparkles } from 'lucide-react';
import { cn } from '../../lib/utils';
import { useAIAssistantStore } from './store';

export function AIAssistantButton() {
  const { isOpen, toggle } = useAIAssistantStore();

  return (
    <button
      onClick={toggle}
      className={cn(
        'fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full shadow-lg transition-all',
        'bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700',
        'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2',
        isOpen && 'opacity-0 pointer-events-none'
      )}
      aria-label="Open AI Assistant"
    >
      <div className="relative">
        <Bot className="h-6 w-6 text-white" />
        <Sparkles className="absolute -top-1 -right-1 h-3 w-3 text-yellow-300 animate-pulse" />
      </div>
    </button>
  );
}
